import { StyleSheet } from 'aphrodite';
// loading动画
const loading = {
  '0%': {
    transform: 'scale(1)',
    opacity: 1,
  },
  '45%': {
    transform: 'scale(0.1)',
    opacity: 0.7,
  },
  '80%': {
    transform: 'scale(1)',
    opacity: 1,
  },
};

export default StyleSheet.create({
  container: {
    width: '100%',
  },

  audioBox: {
    position: 'relative',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    fontSize: 14,
    height: 64,
    lineHeight: '64px',
    paddingRight: 20,
  },

  audioTime: {
    width: 40,
  },

  mask: {
    flex: 1,
    flexDirection: 'row',
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    backgroundColor: 'rgba(255,255,255,.6)',
    transform: 'scale(1)',
    justifyContent: 'center',
    alignItems: 'center',
  },

  maskError: {
    flex: 1,
    flexDirection: 'row',
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    fontSize: 12,
    backgroundColor: 'rgba(255,255,255,.6)',
    color: '#FD5454',
    justifyContent: 'center',
  },

  spot: {
    backgroundColor: '#C3CCD1',
    width: 10,
    height: 10,
    borderRadius: '100%',
    margin: 2,
    animationFillMode: 'both',
    display: 'inline-block',
    ':nth-child(1)': {
      animationName: [loading],
      animationDuration: '0.75s',
      animationTimingFunction: 'cubic-bezier(0.2, 0.68, 0.18, 1.08)',
      animationDelay: '-0.24s',
      animationIterationCount: 'infinite',
    },
    ':nth-child(2)': {
      animationName: [loading],
      animationDuration: '0.75s',
      animationTimingFunction: 'cubic-bezier(0.2, 0.68, 0.18, 1.08)',
      animationDelay: '-0.12s',
      animationIterationCount: 'infinite',
    },
    ':nth-child(3)': {
      animationName: [loading],
      animationDuration: '0.75s',
      animationTimingFunction: 'cubic-bezier(0.2, 0.68, 0.18, 1.08)',
      animationDelay: '0s',
      animationIterationCount: 'infinite',
    },
  },

  default: {
    marginRight: 10,
    marginLeft: 10,
    width: 40,
    height: 40,
    backgroundSize: '100%',
    cursor: 'pointer',
  },

  disable: {
    opacity: 0.5,
    cursor: 'not-allowed',
  },

  defaultSmall: {
    width: 28,
    height: 28,
    backgroundSize: '100%',
    cursor: 'pointer',
  },

  playPrev: {
    backgroundImage: `url(${require('./assets/prev.png')})`,
  },

  backward: {
    marginLeft: 10,
    backgroundImage: `url(${require('./assets/backward.png')})`,
  },

  forward: {
    marginRight: 10,
    backgroundImage: `url(${require('./assets/forward.png')})`,
  },

  play: {
    backgroundImage: `url(${require('./assets/play.png')})`,
  },

  pause: {
    backgroundImage: `url(${require('./assets/pause.png')})`,
  },

  playNext: {
    marginRight: 40,
    backgroundImage: `url(${require('./assets/next.png')})`,
  },

  progressBox: {
    position: 'relative',
    marginLeft: 10,
    marginRight: 10,
    height: 10,
  },

  progress: {
    position: 'relative',
    marginTop: 2.5,
    width: '100%',
    height: 5,
    borderRadius: '2.5px',
    backgroundColor: '#dce6ec',
    cursor: 'pointer',
  },

  blueProgress: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: 5,
    borderRadius: '2.5px',
    background: 'linear-gradient(to right, #7D9FE9, #385DAE)',
  },

  fullMask: {
    position: 'fixed',
    zIndex: 10,
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
  },

  audioIcon: {
    width: 40,
    height: 40,
  },

  IconWrapper: {
    position: 'relative',
    width: 40,
    height: 40,
    marginLeft: 24,
    cursor: 'pointer',
    ':first-child': {
      marginLeft: 40,
    },
  },

  volumeBox: {
    position: 'absolute',
    zIndex: 20,
    width: 40,
    height: 100,
    left: 0,
    top: -106,
    backgroundColor: '#fff',
    borderRadius: 3,
    border: '1px solid #C3CCD1',
  },

  volumeProcessBarWrapper: {
    position: 'relative',
    margin: '0 auto',
    marginTop: 11,
    width: 2,
    height: 80,
    backgroundColor: '#385DAE',
    borderRadius: 1,
  },

  volumeProcessBar: {
    width: 2,
    backgroundColor: '#DCE6EC',
    borderRadius: 1,
  },

  volumeProcessCircle: {
    position: 'absolute',
    width: 10,
    height: 10,
    left: -4,
    border: '1px solid #878F98',
    borderRadius: 11,
    backgroundColor: '#fff',
    cursor: 'pointer',
    transition: 'background-color .15s',
    userSelect: 'none',
    ':hover': {
      backgroundColor: '#f5f5f5',
    },
  },

  grayTriangle: {
    position: 'absolute',
    width: 0,
    height: 0,
    bottom: -6,
    left: 14,
    borderLeft: '5px solid transparent',
    borderRight: '5px solid transparent',
    borderTop: '6px solid #C3CCD1',
  },

  whiteTriangle: {
    position: 'absolute',
    width: 0,
    height: 0,
    bottom: -4,
    left: 14,
    borderLeft: '5px solid transparent',
    borderRight: '5px solid transparent',
    borderTop: '6px solid #fff',
  },

  loopBox: {
    position: 'absolute',
    paddingTop: 12,
    zIndex: 20,
    width: 80,
    height: 151,
    left: -22,
    top: -155,
    backgroundColor: '#fff',
    borderRadius: 3,
    border: '1px solid #C3CCD1',
  },

  loopTriangle: {
    left: 32,
  },

  loopText: {
    height: 25,
    lineHeight: '25px',
    fontSize: 12,
    color: '#878F98',
    textAlign: 'center',
    cursor: 'pointer',
  },

  speedWrapper: {
    lineHeight: '40px',
    fontSize: 18,
    color: '#878F98',
    textAlign: 'center',
  },

  speedBox: {
    position: 'absolute',
    paddingTop: 12,
    zIndex: 20,
    width: 80,
    height: 127,
    left: -22,
    top: -133,
    backgroundColor: '#fff',
    borderRadius: 3,
    border: '1px solid #C3CCD1',
  },

  dot: {
    position: 'absolute',
    top: '-1px',
    width: 12,
    height: 12,
    borderRadius: '12px',
    backgroundColor: '#fff',
    border: 'solid 1px #878f98',
  },
});



// WEBPACK FOOTER //
// ./src/components/listen/audioCtx/styles.js